import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireCapability } from './components/RequireCapability';
import { AuditPage } from './pages/AuditPage';
import { EventsPage } from './pages/EventsPage';
import { GrantAccessPage } from './pages/GrantAccessPage';
import { ProfilePage } from './pages/ProfilePage';
import { SystemDetailPage } from './pages/SystemDetailPage';
import { SystemsPage } from './pages/SystemsPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { UsersPage } from './pages/UsersPage';
import { AppProvider } from './state/AppContext';
import { ToastProvider } from './state/ToastContext';

export default function App() {
  return (
    <ToastProvider>
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Navigate to="/users" replace />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/users/:id" element={<UserDetailPage />} />
              <Route
                path="/users/:id/grant"
                element={
                  <RequireCapability capability="manageGrants">
                    <GrantAccessPage />
                  </RequireCapability>
                }
              />
              <Route
                path="/systems"
                element={
                  <RequireCapability capability="viewSystems">
                    <SystemsPage />
                  </RequireCapability>
                }
              />
              <Route
                path="/systems/:id"
                element={
                  <RequireCapability capability="viewSystems">
                    <SystemDetailPage />
                  </RequireCapability>
                }
              />
              <Route
                path="/audit"
                element={
                  <RequireCapability capability="viewAudit">
                    <AuditPage />
                  </RequireCapability>
                }
              />
              <Route
                path="/events"
                element={
                  <RequireCapability capability="viewEvents">
                    <EventsPage />
                  </RequireCapability>
                }
              />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="*" element={<Navigate to="/users" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </ToastProvider>
  );
}
